import React from 'react';
import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

type PageTitleProps = {
    title: string;
    dynamicTitle?: () => string;
    allowGoBack?: boolean;
    style?: React.CSSProperties | undefined;
    onGoBackClick?: () => void;
};

const PageTitle: React.FC<PageTitleProps> = ({
    title,
    dynamicTitle,
    allowGoBack,
    style,
    onGoBackClick // ✅ NOVO
}) => {
    const navigate = useNavigate();

    const handleClickGoBack = () => {
        navigate(-1);
    };

    return (
        <span className="pageTitle" style={style}>
            {allowGoBack && (
                <IoArrowBackSharp
                    className="pageTitleBackIcon"
                    onClick={onGoBackClick ?? handleClickGoBack}
                />
            )}
            {dynamicTitle ? dynamicTitle() : title}
        </span>
    );
};

export default PageTitle;
